module.exports = function(app) {
    app.controller("pages.dispute.dispute",[ "$scope", "teamsite", "sessionData", "coremetrics", "$state", 
        function($scope, teamsite, sessionData, coremetrics, state) {

       }
    ]);
}